import React, { Component } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import { TextField } from "@material-ui/core";
import { getSimpleList } from "../crud/admin.crud";
import _ from "lodash";

export default class AdminAutoComplete extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
        };
    }

    onSearch = _.debounce((text) => {
        getSimpleList({ search_param: text, tipo_usuario: this.props?.tipo ?? "" }).then((res) => {
            this.setState({ data: res.data });
        });
    }, 500);

    render() {
        const { setValue, value, disabled, tipo, touched, errors, required, label } = this.props;
        const input_label = required ? `${label ?? tipo} *` : label ?? tipo;

        return <>{!disabled ? <Autocomplete className="select-tabela" loadingText={"Carregando..."} noOptionsText="Sem resultados." clearOnBlur={true} value={value} onChange={(_, value) => setValue(value)} onInputChange={(_, term) => this.onSearch(term)} onFocus={(event) => this.onSearch(event.target.value)} options={this.state.data} getOptionLabel={(option) => (option ? option?.adm_nome : "")} renderInput={(params) => <TextField {...params} label={input_label} margin="normal" variant="outlined" helperText={touched && errors} error={Boolean(touched && errors)} />} /> : <TextField label={input_label} margin="normal" variant="outlined" disabled value={value?.adm_nome} />}</>;
    }
}
